import { FormEvent, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import removeAllErrorMsg from "../../components/funcRemoveAllErros";
import { ApiEndpoints, reqPostDownloadFile } from "../../config/apiClient";
import { toast } from "react-toastify";
import dayjs from "dayjs";

function ModalQrCodesRelatorio({ show, handleClose }:iProps) {
    const [loading, setLoading] = useState<boolean>(false)
    const [mostrarAtivos, setMostrarAtivos] = useState<boolean>(true)
    const [mostrarInativos, setMostrarInativos] = useState<boolean>(true)

    function handleSubmitRelatorio(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()
        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true
        let dados = {
            mostrar_ativos: form.mostrar_ativos.value === "true" ? true : false,
            mostrar_inativos: form.mostrar_inativos.value === "true" ? true : false,
            qtdDias: form.qtd_dias.value,
            inativar: false,
            download: true,
        }
        console.log(dados)
        if (dados.qtdDias === "" || Number(dados.qtdDias) === 0) {
            form.qtd_dias.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (!formValidado) {
            return
        }

        dados.qtdDias = Number(dados.qtdDias)

        download(dados)
    }

    async function download(dados:any) {
        setLoading(true)
        let arquivo:string = `Relatorio-Ronda-QrCodes-Situacao-${dayjs().format("DD-MM-YYYY")}.pdf`
        let response = await reqPostDownloadFile(ApiEndpoints.qrcodeListarDownloadRelatorio, dados, arquivo)
        if (response.status === 200) {
            toast.success('Aguarde o termino do download...', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        } else {
            toast.error('Erro no download, tente mais tarde ou verifique com o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setLoading(false)
    }

    function handleChangeMostrarAtivos(event:any) {
        console.log(event)
        if (event.target.value === 'true') {
            setMostrarAtivos(true)
        } else if (event.target.value === 'false') {
            setMostrarAtivos(false)
        }
    }
    
    function handleChangeMostrarInativos(event:any) {
        console.log(event)
        if (event.target.value === 'true') {
            setMostrarInativos(true)
        } else if (event.target.value === 'false') {
            setMostrarInativos(false)
        }
    }

    const customStyleForRadioDiv:React.CSSProperties = {
        display: 'inline-flex',
        alignItems: 'center',
        margin: '0px 10px 0px 0px',
        padding: '0px'
    }

    const customStyleForRadioDivInput:React.CSSProperties = {
        padding: '0px',
        margin: '0px',
        cursor: 'pointer'
    }

    const customStyleForRadioDivLabel:React.CSSProperties = {
        padding: '2px 0px 0px 10px',
        margin: '0px',
        cursor: 'pointer'
    }

    return (
        <Modal
            id="modalImportarCnv"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Relatório Ronda - QR Codes Situação</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formRelatorioCnv`} onSubmit={handleSubmitRelatorio} noValidate>
                    <Row>
                        
                        <Col className="col-6">
                            <Form.Group>
                                <Form.Label>Informe quantidade de dias:</Form.Label>
                                <Form.Control name='qtd_dias' type="number" id='qtd_dias' defaultValue={60} placeholder=""/>
                                <Form.Control.Feedback type="invalid">
                                    Informe os dias!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Mostrar Ativos:</Form.Label><br></br>
                            <div className="form-check" style={customStyleForRadioDiv}>
                                <input className="form-check-input" type="radio" name="mostrar_ativos" id="mostrar_ativos_sim" value={'true'} style={customStyleForRadioDivInput} checked={mostrarAtivos === true ? true : false} onChange={handleChangeMostrarAtivos} />
                                <label className="form-check-label" htmlFor="mostrar_ativos_sim" style={customStyleForRadioDivLabel}>Sim</label>
                            </div>
                            <div className="form-check" style={customStyleForRadioDiv}>
                                <input className="form-check-input" type="radio" name="mostrar_ativos" id="mostrar_ativos_nao" value={'false'} style={customStyleForRadioDivInput} checked={mostrarAtivos === false ? true : false} onChange={handleChangeMostrarAtivos} />
                                <label className="form-check-label" htmlFor="mostrar_ativos_nao" style={customStyleForRadioDivLabel}>Não</label>
                            </div>
                        </Form.Group>    
                        </Col>
                        
                        <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Mostrar Inativos:</Form.Label><br></br>
                            <div className="form-check" style={customStyleForRadioDiv}>
                                <input className="form-check-input" type="radio" name="mostrar_inativos" id="mostrar_inativos_sim" value={'true'} style={customStyleForRadioDivInput} checked={mostrarInativos === true ? true : false} onChange={handleChangeMostrarInativos} />
                                <label className="form-check-label" htmlFor="mostrar_inativos_sim" style={customStyleForRadioDivLabel}>Sim</label>
                            </div>
                            <div className="form-check" style={customStyleForRadioDiv}>
                                <input className="form-check-input" type="radio" name="mostrar_inativos" id="mostrar_inativos_nao" value={'false'} style={customStyleForRadioDivInput} checked={mostrarInativos === false ? true : false} onChange={handleChangeMostrarInativos} />
                                <label className="form-check-label" htmlFor="mostrar_inativos_nao" style={customStyleForRadioDivLabel}>Não</label>
                            </div>
                        </Form.Group>    
                        </Col>

                    </Row>
                    <br/>
                    <Button type="submit" disabled={loading} style={{marginRight: "10px"}}>{loading ? "Aguarde..." : "Download"}</Button>
                </Form>

                <br></br>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )

}

interface iProps {
    show: boolean,
    handleClose: any,
}

export default ModalQrCodesRelatorio;
